import GenericProfileView from './GenericProfileView';

export default GenericProfileView;